import { Temporal } from 'temporal-polyfill';

export const VERMONT_TIME_ZONE = 'America/New_York';
const VERMONT_LOCALE = 'en-US';

const datePartsFormatter = new Intl.DateTimeFormat(VERMONT_LOCALE, {
    timeZone: VERMONT_TIME_ZONE,
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
});

const getVermontDateParts = (date: Date): Record<string, number> => Object.fromEntries(
    datePartsFormatter.formatToParts(date)
        .filter((part) => part.type !== 'literal')
        .map((part) => [part.type, Number(part.value)])
) as Record<string, number>;

export const displayDateTimeAsVtTime = (date: Date): string => date.toLocaleString(VERMONT_LOCALE, {
    timeZone: VERMONT_TIME_ZONE, year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
});

export const displayTimeAsVtTime = (date: Date): string => date.toLocaleString(VERMONT_LOCALE, {
    timeZone: VERMONT_TIME_ZONE, hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
});

export const displayFullDateAsVtTime = (date: Date): string => date.toLocaleDateString(VERMONT_LOCALE, {
    timeZone: VERMONT_TIME_ZONE, year: 'numeric', month: 'numeric', day: 'numeric'
});

// Used by course date cards, which intentionally show only the day of month.
export const displayDateAsVtTime = (date: Date): string => date.toLocaleString(VERMONT_LOCALE, {
    timeZone: VERMONT_TIME_ZONE, day: 'numeric'
});

export const displayMonthAsVtTime = (date: Date): string => date.toLocaleString(VERMONT_LOCALE, {
    timeZone: VERMONT_TIME_ZONE, month: 'short'
});

export const displayYearMonthAsVtTime = (date: Date): string => {
    const { year, month } = getVermontDateParts(date);
    return `${year}-${String(month).padStart(2, '0')}`;
};

// react-datetime-picker reads local Date fields. Build a display-only local Date whose
// fields match the stored instant when viewed in Vermont time.
export const displayDateTimeForDatepicker = (date: Date): Date => {
    const { year, month, day, hour, minute, second } = getVermontDateParts(date);
    return new Date(year, month - 1, day, hour, minute, second);
};

// Interpret picker fields as a Vermont wall-clock value and return its instant.
export const inputAsVtTime = (date: Date): Date => {
    const zonedDateTime = Temporal.ZonedDateTime.from({
        timeZone: VERMONT_TIME_ZONE,
        year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate(),
        hour: date.getHours(), minute: date.getMinutes(), second: date.getSeconds(),
        millisecond: date.getMilliseconds()
    });

    return new Date(zonedDateTime.epochMilliseconds);
};